import { request } from "../../api/api";

export const getStationTopic = (params) => {
  return request.post(`/production_line/getStationTopic/`, params);
};
export const getAllStationTopics = (params) => {
  return request.get(`/production_line/getAllStationTopics/`, params);
};

export const getBatchStationTracking = (id) => {
  return request.get(
    `/production_line/getBatchStationTracking/?batch_id=${id}`
  );
};

export const getBatchId = (id) => {
  return request.get(`/getBatch/${id}`);
};
export const getDippingBatchHistoryDetails = (searchParams) => {
  const { search, rowsPerPage, page } = searchParams;

  if (!search) {
    console.error("Search parameters are missing");
    return;
  }

  let queryParams = new URLSearchParams();

  if (search.B_No) queryParams.append("batch_type", search.B_No);
  if (search.Lot_No) queryParams.append("lot_number", search.Lot_No);
  if (search.Lot_No) queryParams.append("lot_number", search.Lot_No);
  if (search.Scre) queryParams.append("scre", search.Scre);
  if (search.Class) queryParams.append("class_id__class_name", search.Class);
  if (search.Size) queryParams.append("size__size_name", search.Size);
  if (search.currentbatch) queryParams.append("current_batch_station", search.currentbatch);
  queryParams.append("page", page + 1);

  return request.get(`production_line/getDippingBatchHistoryDetails/?${queryParams.toString()}`);
};

export const getOutFeedDefectsList = () => {
  return request.get(`/production_line/getOutFeedDefectsList/`);
};
export const getOutFeedVisualInspectionData = (id) => {
  return request.get(
    `/production_line/getOutFeedVisualInspectionData/?batch_id=${id}`
  );
};

export const failOutFeedInspection = (params) => {
  return request.post(`/production_line/failOutFeedInspection/`, params);
};
export const getLeachingStationDetails = (id) => {
  return request.get(
    `/production_line/getLeachingStationDetails/?batch_id=${id}`
  );
};
export const updateLeachingStationDetails = (params) => {
  return request.post(`/production_line/updateLeachingStationDetails/`, params);
};
export const getTunnelOvenStationDetails = (id) => {
  return request.get(
    `production_line/getTunnelOvenStationDetails/?batch_id=${id}`
  );
};
export const getStrippingStationDetails = (id) => {
  return request.get(
    `production_line/getStrippingStationDetails/?batch_id=${id}`
  );
};
export const getStaticLeachingStationDetails = (id) => {
  return request.get(
    `production_line/getStaticLeachingStationDetails/?batch_id=${id}`
  );
};
export const getWashineMachine1StationDetails = (id) => {
  return request.get(
    `production_line/getWashineMachine1StationDetails/?batch_id=${id}`
  );
};
export const getTumbleDrying1StationDetails = (id) => {
  return request.get(
    `production_line/getTumbleDrying1StationDetails/?batch_id=${id}`
  );
};
export const getTumbleDrying2StationDetails = (id) => {
  return request.get(
    `production_line/getTumbleDrying2StationDetails/?batch_id=${id}`
  );
};
export const getProngOven1StationDetails = (id) => {
  return request.get(
    `production_line/getProngOven1StationDetails/?batch_id=${id}`
  );
};
export const getProngOven2StationDetails = (id) => {
  return request.get(
    `production_line/getProngOven2StationDetails/?batch_id=${id}`
  );
};
export const getProngOven3StationDetails = (id) => { 
  return request.get(
    `production_line/getProngOven3StationDetails/?batch_id=${id}`
  );
};
export const getProngOven4StationDetails = (id) => {
  return request.get(
    `production_line/getProngOven4StationDetails/?batch_id=${id}`
  );
};
export const getAutoclaveStationDetails = (id) => {
  return request.get(
    `production_line/getAutoclaveStationDetails/?batch_id=${id}`
  );
};
export const getCuttingStationDetails = (id) => {
  return request.get(
    `production_line/getCuttingStationDetails/?batch_id=${id}`
  );
};
export const getWashineMachine2StationDetails = (id) => {
  return request.get(
    `production_line/getWashingMachine2StationDetails/?batch_id=${id}`
  );
};
export const getAcConditioningStationDetails = (id) => {
  return request.get(
    `production_line/getACConditioningStationDetails/?batch_id=${id}`
  );
};
export const getHancoMachineStationDetails = (id) => {
  return request.get(
    `production_line/getHancoWashingStationDetails/?batch_id=${id}`
  );
};
export const getChlorinationStationDetails = (id) => {
  return request.get(
    `production_line/getChlorinationStationDetails/?batch_id=${id}`
  );
};
export const getExtraAcConditionerStationDetails = (id) => {
  return request.get(
    `production_line/getExtraACConditionerStationDetails/?batch_id=${id}`
  );
};
export const updateAcConditionerStationDetails = (params) => {
  return request.post(
    `production_line/updateACConditioningStationDetails/`,
    params
  );
};
export const updateHancoWashingStationDetails = (params) => {
  return request.post(
    `production_line/updateHancoWashingStationDetails/`,
    params
  );
};
export const updateExtraAcConditionerStationDetails = (params) => {
  return request.post(
    `production_line/updateExtraACConditionerStationDetails/`,
    params
  );
};
export const updateStaticLeaching = (params) => {
  return request.post(
    `production_line/updateStaticLeaching/`,
    params
  );
};
export const updateCutting = (params) => {
  return request.post(
    `production_line/updateCutting/`,
    params
  );
};
export const updateChlorination = (params) => {
  return request.post(
    `production_line/updateChlorination/`,
    params
  );
};
export const submitOutFeedVisualInspection = (params) => {
  return request.post(
    `production_line/submitOutFeedVisualInspection/`,
    params
  );
};
export const updateWM1StationDetails = (params) => {
  return request.post(`production_line/updateWM1StationDetails/`, params);
};
export const updateWM2StationDetails = (params) => {
  return request.post(`production_line/updateWM2StationDetails/`, params);
};
export const updateLeachingDetails = (params) => {
  return request.post(`production_line/updateLeachingStationDetails/`, params);
};
export const assignBatchStripping = (params) => {
  return request.post(`/production_line/assignBatchToStripping/`, params);
};
export const scanTrayQR = (params) => {
  return request.post(`/production_line/scanTrayQR/`, params);
};
export const scanStationQR = (params) => {
  return request.post(`/production_line/scanStationQR/`, params);
};

export const operatorList = ()=>{
  return request.get("/production_line/getOperatorNameList/")
}
export const getUIDPrintingDetails = (id)=>{
  return request.get(`/production_line/getUIDPrintingDetails/?batch_id=${id}`)
}
export const getVisualInspectionDetails = (id)=>{
  return request.get(`/production_line/getVisualInspectionDetails/?batch_id=${id}`)
}

export const getElectricTestData = (id)=>{
  return request.get(`/production_line/getElectricTestData/?batch_id=${id}`)
}

export const updateProngOvenDetails = (params)=>{
  return request.post("/production_line/updateProngOvenDetails/",params)
}
export const updateAutoclave = (params)=>{
  return request.post("/production_line/updateAutoclave/",params)
}
export const updateTunnelOvenStationDetails = (params)=>{
  return request.post("/production_line/updateTunnelOvenStationDetails/",params)
}
export const updateStrippingStationDetails = (params)=>{
  return request.post("/production_line/updateStrippingStationDetails/",params)
}
export const updateTD1StationDetails = (params)=>{
  return request.post("/production_line/updateTD1StationDetails/",params)
}
export const getProngOvenTrolleys = (param) => {
  const queryParam = isNaN(param) ? `station_name=${param}` : `batch_id=${param}`;
  return request.get(`/production_line/getProngOvenTrolleys/?${queryParam}`);
};

export const getStaticLeachingBins = (name)=>{
  return request.get(`/production_line/getStaticLeachingBins/?station_name=${name}`)
}
export const getUltraSonicData = (id)=>{
  return request.get(`/production_line/getUltrasonicRFIDData/?batch_id=${id}`)
}

export const getAssignToStrippingBatchList = (page, rowsPerPage) =>{
  return request.get(`production_line/getAssignToStrippingBatchList/?page=${page + 1}&page_size=${rowsPerPage}`)
}
